<template>
  <page-header :main-title="$t('analyticalModel')">
    <template #tabs>
      <div class="d-flex mt-5">
        <router-link
          v-if="userCanReadEngagementNodeModelGit && showNodeModelGitPages"
          v-slot="{ isActive }"
          :to="{ name: 'AnalyticalModelConfig' }"
        >
          <base-tab :active="isActive">
            <h4>{{ $t('configure') }}</h4>
          </base-tab>
        </router-link>
        <router-link
          v-if="userCanReadEngagementNodeModelGit && showNodeModelGitPages"
          v-slot="{ isActive }"
          :to="{ name: 'AnalyticalModelBuild' }"
        >
          <base-tab :active="isActive">
            <h4>{{ $t('build') }}</h4>
          </base-tab>
        </router-link>
        <router-link
          v-if="showPipelinePages"
          v-slot="{ isActive }"
          :to="{ name: 'AnalyticalModelRunOverview' }"
        >
          <base-tab :active="isActive">
            <h4>{{ $t('run') }}</h4>
          </base-tab>
        </router-link>
        <router-link
          v-if="showPipelinePages"
          v-slot="{ isActive }"
          :to="{ name: 'AnalyticalModelMonitorOverview' }"
        >
          <base-tab :active="isActive">
            <h4>{{ $t('monitor') }}</h4>
          </base-tab>
        </router-link>
        <div class="horizontal-line mt-2">
          <hr />
        </div>
      </div>
    </template>
    <template #subheader>
      <div class="mt-3">
        <h4 v-if="routerName == 'AnalyticalModelConfig'" class="subtitle-2">
          {{ $t('analyticalModelOverviewDesc') }}
        </h4>
        <h4
          v-if="routerName == 'AnalyticalModelBuildingOverview'"
          class="subtitle-2"
        >
          {{ $t('analyticalModelBuildingOverviewDesc') }}
        </h4>
        <h4
          v-if="routerName == 'AnalyticalModelRunOverview'"
          class="subtitle-2"
        >
          {{ $t('analyticalModelRunOverviewDesc') }}
        </h4>
        <h4
          v-if="routerName == 'AnalyticalModelMonitorOverview'"
          class="subtitle-2"
        >
          {{ $t('monitorTabDesc') }}
        </h4>
      </div>
    </template>
  </page-header>
  <div class="mt-6">
    <router-view />
  </div>
</template>
<script lang="ts">
import PageHeader from '@/components/misc/PageHeader.vue';
import BaseTab from '@/components/tabs/BaseTab.vue';
import { computed, ComputedRef, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
export default {
  name: 'AnalyticalModelOverview',
  components: { PageHeader, BaseTab },
  setup() {
    const router = useRouter();
    const store = useStore();
    let routerName = ref(router.currentRoute.value.name);

    const showNodeModelApiPages: ComputedRef<boolean> = computed(
      () => store.getters['home/showNodeModelApiPages']
    );
    const showNodeModelGitPages: ComputedRef<boolean> = computed(
      () => store.getters['home/showNodeModelGitPages']
    );
    const showPipelinePages: ComputedRef<boolean> = computed(
      () => store.getters['home/showPipelinePages']
    );
    const userCanReadEngagementNodeModelGit: ComputedRef<boolean> = computed(
      () => store.getters['userPermissions/canReadEngagementNodeModelGit']
    );

    onMounted(async () => {
      await store.dispatch(
        'userPermissions/checkIfCanReadEngagementNodeModelGit'
      );
    });

    return {
      routerName,
      showNodeModelApiPages,
      showNodeModelGitPages,
      showPipelinePages,
      userCanReadEngagementNodeModelGit
    };
  }
};
</script>
<style scoped lang="scss"></style>
